import {createSelector, Selector} from 'reselect';
import { RootState } from 'store/store';
import { RootModel } from 'store/models';

export const getEntityById = <T>(id: number, entityStore: string) =>
  createSelector<RootModel, { [key: number]: T }, T>(
    (state: RootState) => state[entityStore].ids,
    (entities) => entities[id]
  );

export const getEntitiesByIds = <T>(ids: number[], entityStore: string) =>
  createSelector<RootModel, { [key: number]: T }, T[]>(
    (state: RootState) => state[entityStore].ids,
    (entities) => ids.map((id) => entities[id]).filter(item => !!item)
  );

export const getEntityBySelectId = <T>(selectId: Selector<any, any>, entityStore: string) =>
    createSelector<RootModel, number, { [key: number]: T }, T>(
        selectId,
        (state: RootState) => state[entityStore].ids,
        (id, entities) => entities[id]
    );

export const getEntitiesBySelectIds = <T>(selectIds: Selector<any, any>, entityStore: string) =>
    createSelector<RootModel, number[],{ [key: number]: T }, T[]>(
        selectIds,
        (state: RootState) => state[entityStore].ids,
        (ids, entities) => ids.map((id) => entities[id]).filter((item) => !!item)
    );